/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs */

const en_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stream start`)
};

const ar_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بداية البث`)
};

const bn_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রিম শুরু`)
};

const de_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streamstart`)
};

const es_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio de transmisión`)
};

const fr_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début du flux`)
};

const pt_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início da transmissão`)
};

const zh_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流开始`)
};

const tr_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayın başlangıcı`)
};

const ru_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало трансляции`)
};

const pl_svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Początek strumienia`)
};

/**
* | output |
* | --- |
* | "Stream start" |
*
* @param {Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_work_0_metric_1_label = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Work_0_Metric_1_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
	return en_svc_rag_knowledge_assistants_work_0_metric_1_label(inputs)
});
export { svc_rag_knowledge_assistants_work_0_metric_1_label as "svc_rag-knowledge-assistants_work_0_metric_1_label" }